import { farmResultsViewModel } from "common/viewModels";
import NameValueSplit from "./NameValueSplit";

export default function FarmResults({ analysis }) {
    const nameValues = farmResultsViewModel(analysis).filter((r) => r.key !== "MedianCalvingPeriod");
    return <NameValueSplit nameValues={nameValues} splitBy={2} />;
}
